module.exports = __webpack_public_path__ + "img/EASTASIA_LOW_GLYCEMIC.b230e55a.png";